"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatCurrencyWithCode = _interopRequireDefault(require("../utils/formatCurrencyWithCode"));

var _NumberTypes = _interopRequireDefault(require("../constants/NumberTypes"));

var _NUMBER_FORMATTERS;

var NUMBER_FORMATTERS = (_NUMBER_FORMATTERS = {}, (0, _defineProperty2.default)(_NUMBER_FORMATTERS, _NumberTypes.default.DECIMAL, _I18n.default.formatNumber), (0, _defineProperty2.default)(_NUMBER_FORMATTERS, _NumberTypes.default.CURRENCY, _I18n.default.formatCurrency), (0, _defineProperty2.default)(_NUMBER_FORMATTERS, _NumberTypes.default.PERCENTAGE, _I18n.default.formatPercentage), _NUMBER_FORMATTERS);

var _default = _react.default.createClass({
  displayName: "FormattedNumber",
  propTypes: {
    abbreviate: _react.PropTypes.bool,
    abbreviateThreshold: _react.PropTypes.number,
    currencyCode: _react.PropTypes.string,
    precision: _react.PropTypes.number,
    simplifyCurrency: _react.PropTypes.bool,
    stripInsignificantZeros: _react.PropTypes.bool,
    style: _react.PropTypes.oneOf(Object.keys(_NumberTypes.default).map(function (key) {
      return _NumberTypes.default[key];
    })),
    unit: _react.PropTypes.string,
    useCurrencyCode: _react.PropTypes.bool,
    value: _react.PropTypes.number.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      simplifyCurrency: false,
      stripInsignificantZeros: true,
      style: _NumberTypes.default.DECIMAL
    };
  },
  render: function render() {
    var _this$props = this.props,
        abbreviate = _this$props.abbreviate,
        abbreviateThreshold = _this$props.abbreviateThreshold,
        value = _this$props.value,
        style = _this$props.style,
        simplifyCurrency = _this$props.simplifyCurrency,
        stripInsignificantZeros = _this$props.stripInsignificantZeros,
        useCurrencyCode = _this$props.useCurrencyCode,
        options = (0, _objectWithoutProperties2.default)(_this$props, ["abbreviate", "abbreviateThreshold", "value", "style", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"]);
    var numberFormatter = NUMBER_FORMATTERS[style];

    if (style === _NumberTypes.default.CURRENCY) {
      console.warn('Using FormattedNumber with the currency style is deprecated. Please use FormattedCurrency instead.');
    }

    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }

    if (useCurrencyCode) {
      options.unit = '';
    }

    if (stripInsignificantZeros === false) {
      options.strip_insignificant_zeros = false;
    } else {
      options.strip_insignificant_zeros = true;
    }

    var wrapperAttributes = {};

    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = numberFormatter(value, options);
      options.abbreviate = true;
      options.precision = 0;
    }

    var formattedNumber = numberFormatter(value, options);
    var numberToRender = useCurrencyCode ? (0, _formatCurrencyWithCode.default)(formattedNumber, options.currencyCode) : formattedNumber;
    return _react.default.createElement("span", wrapperAttributes, numberToRender);
  }
});

exports.default = _default;
module.exports = exports.default;